import { CompetitionStatusComponentType } from '../../enums/CompetitionStatusComponentType';
import { isIdentified, isStudent, isRegistrationStage, isRegisteredTeacherOrManager, isUnregisteredTeacherOrManager, isNotRegisteredStudent, isRegisteredStudent, isContestStage, isOpenedDueToEmergency } from './utils';

export const buildCompetitionStatusProps = (state, authState) => {



    // Case 1: לא מזוהה
    if (!isIdentified(authState)) {
        return {
            componentType: CompetitionStatusComponentType.unidentified,
        };
    }
    if (isIdentified(authState) && !authState?.school?.id) {
        return null
    }

    // תחרות נפתחה בחירום – דורס את שאר המקרים
    if (isOpenedDueToEmergency(state) && isStudent(state)) {
        return {
            componentType: CompetitionStatusComponentType.emergencyStudentContestStage,
        };
    }
    if (isOpenedDueToEmergency(state) && !isStudent(state) && !(!isRegisteredTeacherOrManager(state) && isRegistrationStage(state))) {
        return {
            componentType: CompetitionStatusComponentType.emergencyTeacherContestStage,
        };
    }

    // Case 2: מורה או מנהל רשום בשלב רישום
    if (isRegisteredTeacherOrManager(state) && isRegistrationStage(state)) {
        return {
            componentType: CompetitionStatusComponentType.registeredTeacherRegistrationStage,

        };
    }

    // Case 3: תלמיד בשלב רישום
    if (isStudent(state) && isRegistrationStage(state)) {
        return {
            componentType: CompetitionStatusComponentType.studentRegistrationStage,
        };
    }

    // Case 4: מורה או מנהל לא רשום בשלב רישום
    if (isUnregisteredTeacherOrManager(state) && isRegistrationStage(state)) {
        return {
            componentType: CompetitionStatusComponentType.unregisteredTeacherRegistrationStage,
        };
    }

    // Case 5: תלמיד לא רשום בשלב התחרות
    if (isNotRegisteredStudent(state) && isContestStage(state)) {
        return {
            componentType: CompetitionStatusComponentType.unregisteredStudentContestStage,
        };
    }

    // Case 6: מורה ומנהל לא רשום בשלב התחרות
    if (isUnregisteredTeacherOrManager(state) && isContestStage(state)) {
        return {
            componentType: CompetitionStatusComponentType.unregisteredTeacherContestStage,
        };
    }

    // Case 7: מורה או מנהל רשום בשלב התחרות
    if (isRegisteredTeacherOrManager(state) && isContestStage(state)) {
        return {
            componentType: CompetitionStatusComponentType.registeredTeacherContestStage,
        };
    }

    // Case 8: תלמיד רשום בשלב התחרות
    if (isRegisteredStudent(state) && isContestStage(state)) {
        return {
            componentType: CompetitionStatusComponentType.registeredStudentContestStage,
        };
    }

};
